// @components
import { Button, Form, Select } from "antd";
import Context from "context/appContext";
import { RichText } from "prismic-reactjs";
import React, { useContext, useEffect, useState } from "react";
import { validateForm } from "utils/utils";
import ReactPlayer from 'react-player';
import TagManager from "react-gtm-module";

// @styles
import "./styles.scss";
import { Bounce, Fade } from 'react-reveal'

const mockVal = (str, repeat = 1) => ({
  value: str.repeat(repeat),
});

export default function Banner({ data, handleChange }) {
  const info = data.primary;
  TagManager.initialize({
    gtmId: process.env.REACT_APP_GTM,
  });
  const {
    customRequest,
    dataForm: { formResponses },
    formStatus: { steps },
    progressStep,
    setProgressStep,
    setIsSendForm,
    folio,
    setFolio,
    setVehicleMake,
  } = useContext(Context);
  const [infoAuto, setinfoAuto] = useState([]);
  const [form] = Form.useForm();
  const [vehiculo, setVehiculo] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getCatalog();
  }, []);

  const getCatalog = async () => {
    const options = JSON.parse(process.env.REACT_APP_OPTIONS_CATALOG);
    const response = await customRequest(
      options.url,
      options.header,
      options.method,
      {}
    );
    if (response && response.data) {
      setinfoAuto(response.data);
    }

  };
  const onFinish = async () => {
    if (await validateForm(["vehiclemake"], form)) {
      if (!folio) {
        setLoading(true);
        const options = JSON.parse(process.env.REACT_APP_GENERATE_FOLIO);
        const response = await customRequest(
          options.url,
          options.header,
          options.method,
          {}
        );
        if (response && response.success && response.respuesta) {
          const nFolio = response.respuesta.numFolio;
          if (steps && steps.length) {
            const { questions } = steps[0];
            const findStep = questions[0].newItems.find(
              (step) => step.label === "Folio"
            );
            if (findStep) {
              findStep.value = nFolio;
              formResponses.push(findStep);
            }
          }
          setFolio(nFolio);
        }

      }
      window.dataLayer.push({ 
        'event' : 'mov_01_vehiculo_tipo1',
        'vehiculo' : vehiculo
        });     

      //setIsSendForm(true);
      //setProgressStep([...progressStep]);
      setLoading(false);
      handleChange(null);
    }
  };


  const onChange = (value) => {
    if (infoAuto.length === 0) {
      setinfoAuto([
        { label: "Cargando...", value: "Cargando", disabled: true },
      ]);
    }
    const selected = infoAuto.find((auto) => auto.description === value);
    let fieldInfo = {
      key: "vehiclemake",
      value: selected.key,
      description: selected.description,
    };
    const index = formResponses.findIndex((x) => x.key === fieldInfo.key);
    index != -1
      ? (formResponses[index].value = value)
      : formResponses.push(fieldInfo);
    setVehicleMake(value);
    setVehiculo(value);
  };

  const getValues = () => {
    if (infoAuto.length === 0) {
      setinfoAuto([
        { label: "Cargando...", value: "Cargando", disabled: true },
      ]);
    }
  };

  const [mediaValue, setMediaValue] = useState(256);

  useEffect(async () => {
    const isSmall = window.matchMedia("(max-height: 660px)").matches;
    setMediaValue(isSmall ? 130 : 256);
  }, []);

  return (
    <div className="banner__container" id={info.idcontent}>
      <Fade bottom cascade delay={0.3}>
        <div className="container-xl">
          <div className="banner__container-text">
            {info.sectiontitle && (
              <div className="banner__container-text-title">
                <RichText render={info.sectiontitle} />
              </div>
            )}
            {info.sectiondescription && (
              <div className="banner__container-text-description">
                {info.sectiondescription ? info.sectiondescription : ""}
              </div>
            )}
            <Form form={form} name="control-hooks">
              <div id="vehiclemake">
                <Form.Item
                  name="vehiclemake"
                  label="ELIGE TU VEHÍCULO"
                  rules={[
                    {
                      required: true,
                      message: "Debes elegir tu vehículo",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Búscalo aquí"
                    notFoundContent={"No se encontraron coincidencias"}
                    onChange={onChange}
                    onFocus={getValues}
                    key={"Automovil"}
                    getPopupContainer={() =>
                      document.getElementById("vehiclemake")
                    }
                    data-testid="select"
                    filterOption={(input, option) =>
                      option?.props?.children
                        ?.toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    listHeight={mediaValue}
                  >
                    {infoAuto &&
                      infoAuto.length &&
                      infoAuto.map((value) => (
                        <Select.Option
                          value={
                            value.description ? value.description : value.value
                          }
                          key={value.key || value.description}
                          disabled={value.disabled}
                        >
                          {value.description ? value.description : value.label}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </div>
            </Form>
            {info.buttonname && (
              <Bounce delay={8}>
                <Button
                  className="ant-btn-solid c-3 ant-btn-size-xs"
                  onClick={onFinish}
                  loading={loading}
                  data-testId={info.buttonname}
                >
                  <div>{info.buttonname}</div>
                </Button>
              </Bounce>
            )}
          </div>
          <div className="banner__container-img">
            {info.image && info.image.url ?
              <img
                src={info.image && info.image.url ? info.image.url : ""}
                alt={info?.image?.alt}
              />
              :
              <ReactPlayer
                url={info.video && info.video.url ? info.video.url : ""}
                playing={true}
                loop={true}
                muted
              />
            }
          </div>
        </div>
      </Fade>
    </div>
  );
}
